import { Position } from '../Models/Shared/Position';
import { Dimension } from '../Models/Shared/Dimension';

export type Points = { x: number; y: number }[];

export const getRotatedPoints = (points: Points, cx: number, cy: number, angle: number) => {
    const theta = (angle * Math.PI) / 180;
    const corners = [...points];

    const rotatePoint = (px: number, py: number) => {
        const dx = px - cx;
        const dy = py - cy;
        const xRot = dx * Math.cos(theta) - dy * Math.sin(theta) + cx;
        const yRot = dx * Math.sin(theta) + dy * Math.cos(theta) + cy;

        return { x: xRot, y: yRot };
    };

    return corners.map((c) => rotatePoint(c.x, c.y));
};

export const toPoints = (position: Position, dimension: Dimension): Points => {
    const { x, y } = position;
    const { width, height } = dimension;

    return [
        { x, y }, // left top
        { x: x + width, y }, // right top
        { x: x + width, y: y + height }, // right btm
        { x, y: y + height }, // left btm
    ];
};

export const sortPoints = (points: Points) => {
    const cx = points.reduce((s, p) => s + p.x, 0) / 4;
    const cy = points.reduce((s, p) => s + p.y, 0) / 4;

    return points
        .map((p) => ({
            ...p,
            angle: Math.atan2(p.y - cy, p.x - cx),
        }))
        .sort((a, b) => a.angle - b.angle)
        .map((p) => ({ x: p.x, y: p.y }));
};
